import React, { useState } from "react";
import Button from "react-bootstrap/Button";
import "./Parse.css";

function Parse() {
  const [value, setValue] = useState("");
  const [clicked, setClicked] = useState(false);
  const [testInput] = "";
  const handleChange = (event) => {
    setValue(event.target.value);
  };

  const handleSubmit = (event) => {
    const input = value;
    const array = input.split(/\r?\n/);
    let temp = "";
    let output = "";
    for (let i = 0; i < array.length; i++) {
      temp = array[i].replace(/\D/g, "");
      if (temp.length > 0) {
        if (i === array.length - 1) {
          output += temp;
        } else {
          output += temp;
          output += ", ";
        }
      }
    }
    setValue(output);
    event.preventDefault();
  };

  return (
    <div id="form">
      <form onSubmit={handleSubmit} className="mb-3">
        <label>
          <div>
            <textarea
              type="text"
              value={clicked ? value : testInput}
              onChange={handleChange}
              rows={5}
              cols={40}
              onClick={() => setClicked(true)}
            />
          </div>
        </label>
        <div>
          <Button onClick={handleSubmit} variant="secondary">
            Generate List
          </Button>
          <div>
            <div className="portfolio-bfa-sample-container">
              <div>Removes letters and converts new lines into commas</div>
              <div>Sample Input:</div> <div>ABCD13838</div>{" "}
              <div>BBBB102982</div> <div>CCC171717</div>{" "}
              <div>Sample Output: 13838, 102982, 171717</div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
}

export default Parse;
